module.exports = __webpack_public_path__ + "static/img/hello-hr.be549c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/hello-hr.png
// module id = /oxE
// module chunks = 0